// 작업개시 중인 상품 하나의 진행 — 화면 store 의 상품 상태 칸을 그대로 읽는다(지어낸 진행 없음).
// 작업개시는 상품마다 한 번만 진척을 내서 옵션 많은 상품(대표이미지 옵션×2분)은 «작업개시 1/1» 에서
// 몇십 분 멈춘 듯 보였다(10-20 윈 outbox 3239 · 43옵션). 끝난 작업 수·도는 작업·대표이미지 옵션 수를 싣는다.
export const WORK_TASKS = ['seo', 'pricing', 'mainImage', 'additionalImage', 'detailImage', 'koreanLabel', 'sizeChart', 'quotation']

function taskStatus(product, task) {
  const s = product[`${task}Status`]
  return s && typeof s === 'object' ? s.status : s
}

// { done, total, running: [task], options: { done, total } | null } — 상품이 없으면 null
export function workProgress(product) {
  if (!product) return null
  let done = 0
  let total = 0
  const running = []
  for (const task of WORK_TASKS) {
    const s = taskStatus(product, task)
    if (s === 'disabled') continue // 사이즈표가 필요 없는 카테고리 등 — 할 일이 아니다
    total++
    if (s === 'completed') done++
    // 대표이미지는 옵션 하나가 끝나면 store 가 partially_completed 로 바꾼다(UPDATE_OPTION_IMAGE) — 아직 도는 중
    else if (s === 'processing' || s === 'partially_completed') running.push(task)
  }
  const opts = Array.isArray(product.options) ? product.options : []
  const options = opts.length
    ? { done: opts.filter(o => o && o.mainImageStatus && o.mainImageStatus.status === 'completed').length, total: opts.length }
    : null
  return { done, total, running, options }
}

// «작업 3/7 끝 · 도는 중: 대표 이미지 12/43옵션, 상세 이미지» — nameOf(task) 로 한글 이름
export function workProgressText(p, nameOf = t => t) {
  if (!p) return ''
  let text = `작업 ${p.done}/${p.total} 끝`
  if (p.running.length) {
    const names = p.running.map(t => (t === 'mainImage' && p.options)
      ? `${nameOf(t)} ${p.options.done}/${p.options.total}옵션`
      : nameOf(t))
    text += ` · 도는 중: ${names.join(', ')}`
  }
  return text
}
